import { SessionStore } from './session-store.ts';
import type { AppliedPromoCode, ReservationConfig } from './types.ts';

export interface SecondOpinionReservation {
  specialityId: string;
  description: string;
  urgent?: boolean;
  files?: string[];
  patientName?: string;
  patientBirthDate?: string;
  patientGender?: string;
  doctorName?: string;
  guestEmail?: string;
  appliedPromo?: AppliedPromoCode;
}

export type SecondOpinionReady = SecondOpinionReservation & {
  urgent: boolean;
};

export function isSecondOpinionReady(
  r: SecondOpinionReservation,
): r is SecondOpinionReady {
  return typeof r.urgent === 'boolean';
}

export const secondOpinionReservationStore =
  new SessionStore<SecondOpinionReservation>('second-opinion-reservation');

export const SECOND_OPINION_RESERVATION: ReservationConfig<SecondOpinionReservation> =
  {
    store: secondOpinionReservationStore,
  };
